import React from 'react';
import { Link } from 'react-router-dom';
import { FiFileText, FiUsers, FiPackage, FiBriefcase, FiTool, FiCreditCard, FiGitBranch } from 'react-icons/fi';
import { FaRegHandshake } from 'react-icons/fa';

const cards = [
  { label: 'Pedidos',         desc: 'Gerencie pedidos de venda',       Icon: () => <FiFileText size={24} />,       to: '/listar-pedidos',          color: '#5294b5', bg: '#edf6fb' },
  { label: 'Clientes',        desc: 'Base de clientes',                 Icon: () => <FiUsers size={24} />,          to: '/listar-clientes',         color: '#10b981', bg: '#ecfdf5' },
  { label: 'Produtos',        desc: 'Catálogo de produtos',             Icon: () => <FiPackage size={24} />,        to: '/listar-produtos',         color: '#f59e0b', bg: '#fffbeb' },
  { label: 'Representantes',  desc: 'Equipe de representantes',         Icon: () => <FiTool size={24} />,           to: '/listar-representantes',   color: '#3b82f6', bg: '#eff6ff' },
  { label: 'Formas de Pgto',  desc: 'Formas de pagamento aceitas',      Icon: () => <FiCreditCard size={24} />,     to: '/listar-forma-pagamento',  color: '#8b5cf6', bg: '#f5f3ff' },
  { label: 'Rotas',           desc: 'Rotas de atendimento',             Icon: () => <FiGitBranch size={24} />,      to: '/listar-rotas',            color: '#06b6d4', bg: '#ecfeff' },
  { label: 'Visitas',         desc: 'Histórico de visitas',             Icon: () => <FaRegHandshake size={24} />,   to: '/listar-visitas',          color: '#ec4899', bg: '#fdf2f8' },
  { label: 'Empresa',         desc: 'Dados cadastrais',                 Icon: () => <FiBriefcase size={24} />,      to: '/listar-empresas',         color: '#64748b', bg: '#f1f5f9' },
];

export default function Home() {
  const nome = localStorage.getItem('nome') || '';
  const h    = new Date().getHours();
  const greeting = h < 12 ? 'Bom dia' : h < 18 ? 'Boa tarde' : 'Boa noite';

  return (
    <div style={{ padding: '24px 28px' }}>
      {/* Welcome banner */}
      <div style={{
        marginBottom: 32, padding: '32px 40px', borderRadius: 12, position: 'relative', overflow: 'hidden',
        background: 'linear-gradient(135deg, #0a1520 0%, #1a3347 60%, #1e3a4c 100%)',
      }}>
        <div style={{ position: 'absolute', top: -100, right: -60, width: 320, height: 320, borderRadius: '50%', background: 'rgba(255,255,255,0.05)', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', bottom: -80, left: 40, width: 200, height: 200, borderRadius: '50%', background: 'rgba(255,255,255,0.05)', pointerEvents: 'none' }} />
        <div style={{ position: 'relative' }}>
          <h4 style={{ margin: '0 0 4px', color: '#f8fafc', fontWeight: 800, fontSize: 24 }}>
            {greeting},{' '}
            <span style={{ color: '#90c3d8', textTransform: 'capitalize' }}>
              {nome.split(' ')[0]}
            </span>{' '}👋
          </h4>
          <p style={{ margin: 0, color: '#94a3b8', fontSize: '0.95rem' }}>
            Bem-vindo ao GE Pedido · Painel de gerenciamento completo
          </p>
        </div>
      </div>

      {/* Quick access */}
      <p style={{ margin: '0 0 16px', color: '#64748b', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.07em', fontWeight: 600 }}>
        Acesso rápido
      </p>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
        {cards.map(({ label, desc, Icon, to, color, bg }) => (
          <Link key={to} to={to} style={{ textDecoration: 'none', flex: '1 1 200px', minWidth: 180, maxWidth: 280 }}>
            <div
              style={{
                padding: 20, borderRadius: 10, border: '1.5px solid #e2e8f0',
                background: '#fff', transition: 'all 0.18s ease', cursor: 'pointer',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = color;
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = `0 10px 30px ${color}30`;
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = '#e2e8f0';
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{
                width: 46, height: 46, borderRadius: 10,
                background: bg, color, marginBottom: 16,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <Icon />
              </div>
              <p style={{ margin: '0 0 2px', fontWeight: 700, color: '#0f172a', fontSize: '0.9rem' }}>
                {label}
              </p>
              <span style={{ color: '#94a3b8', fontSize: 12 }}>{desc}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
